import React, { useState } from "react";
import classes from "./MembershipValidationCode.module.css";
import Button from "components/Button";
import Typography from "components/Typography";
import { useMutation } from "@apollo/client";
import { sendPhoneVerificationCodeMutation,  verifyPhoneMutation, membershipValidate } from "../../mutations";
import NotificationPopover from "components/NotificationPopover/NotificationPopover";
import {
  extractSuccess,
  extractServerErrorMessage
} from "utils/extractErrors";
import CodeVerificationControl from "components/form/CodeVerificationControl";
import { SpinnerBack } from "components/Spinner/Spinner";

const extractMembershipValidateSuccess = extractSuccess("membership_validate");
const extractMembershipValidateErrorMessage = extractServerErrorMessage("membership_validate");

const extractPhoneVerifySuccess = extractSuccess("phone_verify");
const extractPhoneVerifyErrorMessage = extractServerErrorMessage("phone_verify");

const extractPhoneVerificationCodeSuccess = extractSuccess("send_phone_verification_code");
const extractPhoneVerificationCodeErrorMessage = extractServerErrorMessage("send_phone_verification_code");

export const MembershipValidationCode = (props) => {
  const {
    phoneNumber,
    clubId,
    onVerified
  } = props;
  const [error, setError] = useState("");
  const [isPhoneVerificationCodeNotification, setIsPhoneVerificationCodeNotification] = useState(false);

  const [membershipValidateAction, { loading: membershipValidateLoading }] = useMutation(membershipValidate, {
    fetchPolicy: "no-cache",
    onCompleted: (response) => {
      if(extractMembershipValidateSuccess({ data: response })) {
        onVerified();
      } else {
        const errorText = extractMembershipValidateErrorMessage({ data: response });
        setError(errorText);
      }
    }
  });

  const [verifyPhoneAction, { loading: verifyPhoneLoading }] = useMutation(verifyPhoneMutation, {
    fetchPolicy: "no-cache",
    onCompleted: (response) => {
      if(extractPhoneVerifySuccess({ data: response })) {
        membershipValidateAction({
          variables: {
            club_id: clubId,
            phone: phoneNumber
          }
        });
      } else {
        const errorText = extractPhoneVerifyErrorMessage({ data: response });
        setError(errorText);
      }
    }
  });

  const [sendPhoneVerificationCodeAction, { loading: sendPhoneVerificationCodeLoading }] = useMutation(sendPhoneVerificationCodeMutation, {
    fetchPolicy: "no-cache",
    onCompleted: (response) => {
      if(!extractPhoneVerificationCodeSuccess({ data: response })) {
        const errorText = extractPhoneVerificationCodeErrorMessage({ data: response });
        setError(errorText);
      }
    }
  });

  return (
    <div className={classes.container}>
      {(membershipValidateLoading || verifyPhoneLoading || sendPhoneVerificationCodeLoading) && <SpinnerBack />}
      <Typography
        variant="subtitle"
        size="s"
        className={classes.subtitle}
      >
        A verification code has been sent to you via text message. Please enter the code to verify your cell phone.
      </Typography>

      <div className="mt-20 mb-20 mb-m-36">
        <CodeVerificationControl
          onComplete={(code) =>
            verifyPhoneAction({
              variables: {
                code
              }
            })}
          disabled={false}
        />
      </div>

      <Button
        secondary
        label="Resend code"
        onClick={sendPhoneVerificationCodeAction}
        className="mt-16 mb-16 mr-16 mr-l-24 mr-xxl-32"
      />

      {error?.length !== 0 && (
        <NotificationPopover
          show={true}
          status="error"
          text={error}
          onClose={() => {
            setError('');
          }}
        />
      )}

      {isPhoneVerificationCodeNotification && (
        <NotificationPopover
          show={true}
          status="error"
          text="Verification code sent successfully. Please check your phone."
          onClose={() => {
            setIsPhoneVerificationCodeNotification(false);
          }}
        />
      )}
    </div>
  );
};
